<mat-card class="__ticket-topic-pop-card  mat-elevation-z5">
  <vshcz-scrollable [maxHeight]="'50vh'">
    <mat-action-list dense>
      <div *ngFor="let item of groupedTopics; let last = last;"
          class="__topic-group"
          [class.has-divider]="!last">

        <h3
          class="__ticket-topic-pop-subheader"
          mat-subheader>
          {{ 'ticketTopics.' + item.key | translate }}
        </h3>

        <button
          mat-list-item
          matRipple
          type="button"
          class="__ticket-topic-pop-button"
          (click)="!!selected.emit(topic.id)"
          *ngFor="let topic of item.items">
          {{ topic._name }}
        </button>

      </div>
    </mat-action-list>
  </vshcz-scrollable>

</mat-card>
